/*globals google*/
(function () {
	'use strict';

	angular
		.module('invesfleet')
		.controller('InformeSensoresController', InformeSensoresController);

	InformeSensoresController.$inject = [
		'$stateParams', 'genericDataService', '$rootScope', '$state',
		'$filter', '$q'];

	/* jshint maxstatements:false */
	/* jshint maxparams:false */
	function InformeSensoresController($stateParams, genericDataService, $rootScope, $state, $filter, $q) {

		/* PUBLIC VARIABLES */
		var vm = this;
		vm.init = init;
		vm.data = {
			fechaIni: '',
			fechaFin: ''
		};
		vm.genericData = {
			comboVehicle: {
				list: null,
				selected: { id: null }
			},
			comboSignal: {
				list: [
					{ id: 1, nombre: 'Señal 1' },
					{ id: 2, nombre: 'Estado Motor' },
					{ id: 3, nombre: 'Señal 2' }
				],
				selected: { id: 1, nombre: 'Señal 1' }
			}
		};
		(function () {
			loadData();
		})();

		function loadData() {
			getGenericData();
		}

		function init(parentVm) {
			parentVm.getData = getData;
		}

		function getGenericData() {
			genericDataService.getFlota().then(function (result) {
				vm.genericData.comboVehicle.list = result;
				vm.genericData.comboVehicle.selected = vm.genericData.comboVehicle.list[0];
			});
		}

		function getData() {
			var data = {};
			data.url = '/INVESFLEET/rpt_activity_signals';
			data.queryType = 'getReports';
			data.message = 'Todos los campos son obligatorios';
			data.valid = doValidation();
			data.datosPeticion = [{ field: 'fechaInicio', value: vm.data.fechaIni },
				{ field: 'fechaFin', value: vm.data.fechaFin },
				{ field: 'flotaId', value: vm.genericData.comboVehicle.selected.id },
				{ field: 'signal', value: vm.genericData.comboSignal.selected.id }];
			return data;
		}

		function doValidation() {
			var valid = true;
			if (!vm.data.fechaIni) { valid = false; }
			if (!vm.data.fechaFin) { valid = false; }
			if (!vm.genericData.comboVehicle.selected.id) { valid = false; }
			if (!vm.genericData.comboSignal.selected.id) { valid = false; }
			return valid;
		}

	}
})();